import Swal from 'sweetalert2';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MatChipInputEvent } from '@angular/material/chips';
import { RestApiProvider } from 'src/app/services/shared/api.service';
import { ToastrService } from 'ngx-toastr';


export interface DialogData {
    i:any;
    recibo:any,
    correo:string,
  }


@Component({
  selector: 'app-send-mail',
  templateUrl: './sendMail.component.html',
})
export class SendMailComponent implements OnInit {
  form3: FormGroup;
  separatorKeysCodes: number[] = [ENTER, COMMA];
  destinatarios: string[] = [];
  facturaSeleccionada: boolean = false;
  comprobanteSeleccionado: boolean = false;
  complementoSeleccionado: boolean = false;
  plantillas: any[] = [];
  historialCorreos: any[] = [];
  creacionExtra: boolean = false;
  editorConfig: AngularEditorConfig = {
      editable: true,
        spellcheck: true,
        height: 'auto',
        minHeight: '0',
        maxHeight: 'auto',
        width: 'auto',
        minWidth: '0',
        translate: 'yes',
        enableToolbar: true,
        showToolbar: true,
        placeholder: 'Enter text here...',
        defaultParagraphSeparator: '',
        defaultFontName: '',
        defaultFontSize: '',
        fonts: [
          {class: 'arial', name: 'Arial'},
          {class: 'times-new-roman', name: 'Times New Roman'},
          {class: 'calibri', name: 'Calibri'},
          {class: 'comic-sans-ms', name: 'Comic Sans MS'},
          {class: 'century-gothic', name: 'Century Gothic'}
        ],
        customClasses: [
        {
          name: 'quote',
          class: 'quote',
        },
        {
          name: 'redText',
          class: 'redText'
        },
        {
          name: 'titleText',
          class: 'titleText',
          tag: 'h1',
        },
      ],
      uploadUrl: 'v1/image',
      uploadWithCredentials: false,
      sanitize: true,
      toolbarPosition: 'top',
      toolbarHiddenButtons: [
        ['bold', 'italic'],
        ['fontSize']
      ]
  };
  
  existeArchivoTipo(nombre:string, tipo: number): boolean {
    return this.data.recibo && this.data.recibo.recibosFile &&
           this.data.recibo.recibosFile.some((archivo: any) => {

            if (nombre && nombre.length > 0){
              return archivo.tipo === tipo && archivo.nombre === nombre
            } else{
              return archivo.tipo === tipo
            }
          });
  }

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    public dialogRef: MatDialogRef<SendMailComponent>,
    private fb: FormBuilder,
    private rest: RestApiProvider,
    private toastr: ToastrService
) {
  console.log(data.correo);
  
  if (this.data['correo'] && this.data['correo'].length > 0 ){
    for (let correo of this.data.correo){
      if (correo && correo.length > 0 ){
        this.destinatarios.push(correo)
      }
    }
  }
}

  ngOnInit(): void {
    this.form3 = this.fb.group({
      subject: ['', Validators.required],
      facturaSeleccionada: [this.existeArchivoTipo('',1)],
      comprobanteSeleccionado: [this.existeArchivoTipo('', 2)],
      complementoSeleccionado: [this.existeArchivoTipo('', 3)],
      message: [`
        <meta charset="UTF-8">
        <title>Recordatorio de Pago - MIURABOX</title>


        <div style="max-width: 600px; margin: auto; background-color: #ffffff; padding: 40px; border-radius: 8px; box-shadow: 0 2px 10px rgba(0,0,0,0.05);">
          
          <!-- Logo -->
          <div style="text-align: center; margin-bottom: 30px;" class="noeditablecontent" contenteditable="false">
            <img src="https://users.miurabox.info/assets/images/logo_mbox.png" alt="MIURABOX" style="height: 40px;">
          </div>

          <!-- Mensaje -->
          <h2 class="noeditablecontent" contenteditable="false" style="color: #1c1c1c;">Buen día, estimado cliente</h2>
          <p>Le recordamos que su mensualidad está próxima a vencer. Para evitar interrupciones en el servicio, le pedimos realizar su pago antes de la fecha límite indicada.</p>
          <p>Una vez realizado el pago, por favor anexe su comprobante en el portal de pagos utilizando el siguiente enlace.</p>

          <!-- Tarjeta de facturación -->
          <div class="noeditablecontent" contenteditable="false" style="background-color: #eef1f5; padding: 20px; border-radius: 12px; margin-top: 20px;">
            <h3 style="margin-top: 0;">Detalles de facturación:</h3>
            <p><strong>Razón Social:</strong> nombre_cliente </p>
            <p><strong>Cliente:</strong> nombre_organizacion </p>
            <p><strong>Monto total:</strong> <span style="color: #007bff;"> monto_total </span></p>
            <p><strong>Fecha límite de pago:</strong> fecha_limite_de_pago </p>
            <p style="margin-top: 20px;"><font size="4"><b><u>Sube tu comprobante aquí:</u></b></font><strong><font size="4"><a href="https://cobranza.mbxservicios.com/login" style="color: rgb(0,0,0); text-decoration: none;">&nbsp;</a><a href="https://cobranza.mbxservicios.com/login" style="color: rgb(0, 123, 255);"><u> Miurabox-Cobranza
                </u></a></font>
              </strong>
            </p>
          </div>

          <!-- Cierre -->
          <p class="noeditablecontent" contenteditable="false" style="margin-top: 40px;">Agradecemos su preferencia.</p>
        </div>

    `, Validators.required],
      plantilla: ['', Validators.required],
    });
    this.editorConfig = {
      editable: true,
      sanitize: false,
      spellcheck: true,
      height: 'auto',
      minHeight: '300px',
      placeholder: 'Escribe aquí...',
      translate: 'no',
      enableToolbar: true,
      showToolbar: true,
    };
    this.rest.cargar_plantillas().then((plantillas:any) => {
        this.plantillas = plantillas;
    });
    this.rest.obtener_historial_correos(this.data.recibo.id).then((correos: any[]) => {
      this.historialCorreos = correos;
    }).catch(() => {
      this.toastr.error('No se pudo cargar el historial de correos');
    });
  }

  verArchivo(url: string) {
    window.open(url, "_blank");
  }

  guardarComoPlantilla(): void {
    let plantillaId = this.form3.get('plantilla').value;
    
    if (plantillaId) {
      const plantillaActual = this.plantillas.find(p => p.url === plantillaId);
      console.log(plantillaActual);
      
      Swal.fire({
        title: 'Actualizar plantilla',
        text: `¿Deseas actualizar la plantilla "${plantillaActual && plantillaActual.nombre}"?`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Sí, actualizar',
        cancelButtonText: 'Cancelar'
      }).then(result => {
        if (result.isConfirmed) {
          const actualizada = {
            html: this.form3.get('message').value,
            subject: this.form3.get('subject').value
          };
          this.rest.parchar_url(plantillaActual.url, actualizada).then((resp: any) => {
            const idx = this.plantillas.findIndex(p => p.url === plantillaId);
            if (idx !== -1) {
              this.plantillas[idx] = resp;
              this.toastr.success('Plantilla actualizada correctamente');
            }
          });
        }
      });
    } else {
      Swal.fire({
        title: 'Nueva Plantilla',
        input: 'text',
        inputPlaceholder: 'Ej. Recordatorio de pago',
        showCancelButton: true,
        confirmButtonText: 'Guardar',
        cancelButtonText: 'Cancelar',
        inputValidator: (value) => {
          if (!value.trim()) {
            return 'Debes escribir un nombre';
          }
          return null;
        }
      }).then(result => {
        if (result.isConfirmed) {
          const nuevaPlantilla = {
            nombre: result.value,
            html: this.form3.get('message').value,
            subject: this.form3.get('subject').value
          };
          this.rest.crear_plantilla(nuevaPlantilla).then((response: any) => {
            this.plantillas.push(response);
            this.form3.get('plantilla').setValue(response.id);
            this.toastr.success('Plantilla creada correctamente');
          });
        }
      });
    }
  }

  addDestinatario(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value.trim();

    if (value && this.validateEmail(value)) {
      this.destinatarios.push(value);
    }

    if (input) {
      input.value = '';
    }
  }

  removeDestinatario(email: string): void {
    const index = this.destinatarios.indexOf(email);
    if (index >= 0) {
      this.destinatarios.splice(index, 1);
    }
  }

  validateEmail(email: string): boolean {
    const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return pattern.test(email);
  }

  cancel() {
    this.dialogRef.close();
  }

  enviarCorreo(): void {
    
    const subject = this.form3.get('subject').value;
    const plantilla = this.form3.get('plantilla').value;

    if (!this.destinatarios.length) {
      this.toastr.error('Debes agregar al menos un destinatario');
      return;
    }

    if (!subject || !subject.trim()) {
      this.toastr.error('El asunto es obligatorio');
      return;
    }

    if (!plantilla) {
      this.toastr.error('Debes seleccionar una plantilla');
      return;
    }

    const datosCorreo = {
      ...this.form3.value,
      destinatarios: (this.destinatarios).toString(),
      recibo: this.data.recibo.url
    };
    this.creacionExtra = true;
    this.rest.enviar_correo_recibo(datosCorreo).then((response:any) => {
      this.creacionExtra = false;
        this.toastr.success('Correo enviado');
        this.cancel();
    }, () => {
      this.creacionExtra = false;
    } )

    // Aquí podrías conectar con un servicio que envíe el correo
  }
  actualizarHtmlPlantilla(id: string): void {
      const plantilla = this.plantillas.find(p => String(p.url) === String(id));
      if (plantilla) {
          this.form3.get('message').setValue(plantilla.html);
          this.form3.get('subject').setValue(plantilla.subject);
        }

    }
}